const ListCN = [
  {
    enteredDate: "2024-10-04T13:51:09.68",
    id: 1,
    enteredBy: "xxxChris Norwood",
    param: "LastDatabaseUpdate",
    value: "32"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 2,
    enteredBy: "xxxChris Norwood",
    param: "AuditLastPurgeDatexxx",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 87,
    enteredBy: "xxxan",
    param: "a",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 88,
    enteredBy: "xxxbn",
    param: "b",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 89,
    enteredBy: "xxxcn",
    param: "c",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 90,
    enteredBy: "xxxdn",
    param: "d",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 91,
    enteredBy: "xxxen",
    param: "e",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 92,
    enteredBy: "xxxfn",
    param: "f",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 93,
    enteredBy: "xxxgn",
    param: "g",
    value: "08/10/2024"
  },
  {
    enteredDate: "2024-10-04T13:51:09.837",
    id: 94,
    enteredBy: "xxxhn",
    param: "h",
    value: "08/10/2024"
  }
];

const ListJs = [
    {
      id:1,
      customer_name: 'Timothy Smith',
      email: 'timothysmith@utelize.com',
      phone: '973-277-6950',
      date: '13 Dec, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:2,
      customer_name: 'Herbert Stokes',
      email: 'herbertstokes@utelize.com',
      phone: '312-944-1448',
      date: '20 Jul, 2021',
      status: 'BLOCK',
      status_color: "danger",
      isSelected:false
    },
    {
      id:3,
      customer_name: 'Charles Kubik',
      email: 'charleskubik@utelize.com',
      phone: '231-480-8536',
      date: '25 Sep, 2021',
      status: 'BLOCK',
      status_color: "danger",
      isSelected:false
    },
    {
      id:4,
      customer_name: 'Glen Matney',
      email: 'glenmatney@utelize.com',
      phone: '515-395-1069',
      date: '02 Nov, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:5,
      customer_name: 'Carolyn Jones',
      email: 'carolynjones@utelize.com',
      phone: '414-453-5725',
      date: '07 Jun, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:6,
      customer_name: 'Kevin Dawson',
      email: 'kevindawson@utelize.com',
      phone: '213-741-4294',
      date: '14 Mar, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:7,
      customer_name: 'Michael Morris',
      email: 'michaelmorris@utelize.com',
      phone: '805-447-8398',
      date: '19 May, 2021',
      status: 'BLOCK',
      status_color: "danger",
      isSelected:false
    },
    {
      id:8,
      customer_name: 'Robert McMahon',
      email: 'robertmcmahon@utelize.com',
      phone: '786-253-9927',
      date: '12 Jan, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:9,
      customer_name: 'Jeff Taylor',
      email: 'jefftaylor@utelize.com',
      phone: '863-577-5537',
      date: '15 Feb, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    },
    {
      id:10,
      customer_name: 'Mary Cousar',
      email: 'marycousar@utelize.com',
      phone: '580-464-4694',
      date: '06 Apr, 2021',
      status: 'ACTIVE',
      status_color: "success",
      isSelected:false
    }
  ];
  
  const dataattribute = [
    {
      id: '1',
      name: 'Gustaf Lindqvist',
      year: '1983',
      img:'assets/images/users/avatar-4.jpg'
    },
    {
      id: '2',
      name: 'Jonas Arnklint',
      year: '1985',
      img:'assets/images/users/avatar-2.jpg'
    },
    {
      id: '3',
      name: 'Jonny Stromberg',
      year: '1986',
      img:'assets/images/users/avatar-1.jpg'
    },
    {
      id: '4',
      name: 'Leia',
      year: '1954',
      img:'assets/images/users/avatar-5.jpg'
    },
    {
      id: '5',
      name: 'Martina Elm',
      year: '1986',
      img:'assets/images/users/avatar-3.jpg'
    }
  ]
  
  const existingList = [
    {
      id: '1',
      name: 'Gustaf Lindqvist',
      time: '01 hrs',
      content:"I've finished it! See you so",
      img:'assets/images/users/avatar-4.jpg'
    },
    {
      id: '2',
      name: 'Jonas Arnklint',
      time: '12 min',
      content:"Bug Report - abc theme",
      img:'assets/images/users/avatar-2.jpg'
    },
    {
      id: '3',
      name: 'Jonny Stromberg',
      time: '06 min',
      content:"New updates for ABC Theme",
      img:'assets/images/users/avatar-1.jpg'
    },
    {
      id: '4',
      name: 'Martina Elm',
      time: '28 min',
      content:"Nice to meet you",
      img:'assets/images/users/avatar-3.jpg'
    }
  ]
  
  const FuzzyList = [
    {
      id: '1',
      name:'Guybrush Threepwood'
    },
    {
      id: '2',
      name:'Elaine Marley'
    },
    {
      id: '3',
      name:'LeChuck'
    },
    {
      id: '4',
      name:'Stan'
    },
    {
      id: '5',
      name:'Voodoo Lady'
    },
    {
      id: '6',
      name:'Herman Toothrot'
    },
    {
      id: '7',
      name:'Meathook'
    },
    {
      id: '8',
      name:'Carla'
    },
    {
      id: '9',
      name:'Otis'
    },
    {
      id: '10',
      name:'Rapp Scallion'
    },
    {
      id: '11',
      name:'Rum Rogers Sr.'
    },
    {
      id: '12',
      name:'Men of Low Moral Fiber'
    },
    {
      id: '13',
      name:'Murray'
    },
    {
      id: '14',
      name:'Cannibals'
    }
  ]
  
  const paginationlist = [
    {
      id: '1',
      name: 'Jonny Stromberg',
      type: 'Front end Developer',
      img:'assets/images/users/avatar-1.jpg'
    },
    {
      id: '2',
      name: 'Jonas Arnklint',
      type: 'Backend Developer',
      img:'assets/images/users/avatar-2.jpg'
    },
    {
      id: '3',
      name: 'Martina Elm',
      type: 'UI/UX Designer',
      img:'assets/images/users/avatar-3.jpg'
    },
    {
      id: '4',
      name: 'Gustaf Lindqvist',
      type: 'Full Stack Developer',
      img:'assets/images/users/avatar-4.jpg'
    },
    {
      id: '5',
      name: 'Jonny Stromberg',
      type: 'Front end Developer',
      img:'assets/images/users/avatar-1.jpg'
    },
    {
      id: '6',
      name: 'Jonas Arnklint',
      type: 'Backend Developer',
      img:'assets/images/users/avatar-2.jpg'
    },
]
  
const GridJs = [
    {
      id: '01',
      name: 'Jonathan',
      email: 'jonathan@example.com',
      position: 'Senior Implementation Architect',
      company: 'Hauck Inc',
      country: 'Holy See',
    },
    {
      id: '02',
      name: 'Harold',
      email: 'harold@example.com',
      position: 'Forward Creative Coordinator',
      company: 'Metz Inc',
      country: 'Iran',
    },
    {
      id: '03',
      name: 'Shannon',
      email: 'shannon@example.com',
      position: 'Legacy Functionality Associate',
      company: 'Zemlak Group',
      country: 'South Georgia',
    },
    {
      id: '04',
      name: 'Robert',
      email: 'robert@example.com',
      position: 'Product Accounts Technician',
      company: 'Hoeger',
      country: 'San Marino',
    },
    {
      id: '05',
      name: 'Noel',
      email: 'noel@example.com',
      position: 'Customer Data Director',
      company: 'Howell - Rippin',
      country: 'Germany',
    },
    {
      id: '06',
      name: 'Traci',
      email: 'traci@example.com',
      position: 'Corporate Identity Director',
      company: 'Koelpin - Goldner',
      country: 'Vanuatu',
    },
    {
      id: '07',
      name: 'Kerry',
      email: 'kerry@example.com',
      position: 'Lead Applications Associate',
      company: 'Feeney, Langworth and Tremblay',
      country: 'Niger',
    },
    {
      id: '08',
      name: 'Patsy',
      email: 'patsy@example.com',
      position: 'Dynamic Assurance Director',
      company: 'Streich Group',
      country: 'Niue',
    },
    {
      id: '09',
      name: 'Cathy',
      email: 'cathy@example.com',
      position: 'Customer Data Director',
      company: 'Ebert, Schamberger and Johnston',
      country: 'Mexico',
    },
    {
      id: '10',
      name: 'Tyrone',
      email: 'tyrone@example.com',
      position: 'Senior Response Liaison',
      company: 'Raynor, Rolfson and Daugherty',
      country: 'Qatar',
    }
  ];
  
  
  
  export { ListCN,ListJs,paginationlist, dataattribute ,existingList, FuzzyList,GridJs };
  